module.exports = __webpack_public_path__ + "media/assets/consultation/project_type_web-7f2aba7ade0b16a0f16e64cfef02acd4.svg";